export default __webpack_public_path__ + "static/nexgen-network-and-application-073e1281fab8973d5a0f0745ee4a2c69.webp";